import styled from 'styled-components';
import { theme } from 'consts/theme';

export const StyledHeaderLeftWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 16px;
  width: 100%;
  color: ${theme.colors.white};
  font-size: 16px;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
`;
